import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { UserGuides } from 'common/api-types/director';

import { fetchUserGuides } from './api';
import type { FetchUserGuidesParams } from './types';

const USER_GUIDES_QUERY_KEY_ROOT = 'userGuides';

type Options = {
  enabled?: boolean;
};

export const useUserGuidesQuery = (
  { venueId, context }: FetchUserGuidesParams,
  options?: Options,
) =>
  useQuery<UserGuides, AxiosError>({
    queryFn: () => fetchUserGuides({ venueId, context }),
    queryKey: [USER_GUIDES_QUERY_KEY_ROOT, { venueId, context }],
    enabled: options?.enabled,
  });
